<template>
  <div class="content content_in">
    <div class="title-row row justify-content-between">
      <div class="col-12 col-md-auto">
        <h1>{{ $t("platforms.title") }}</h1>
      </div>
      <div class="col-12 col-xl-auto flex-grow-1 max-770">
        <div class="row align-items-center">
          <div class="col-12 col-md-6">
            <div class="form-item pb-2">
              <div class="form-item__field">
                <div class="search-field">
                  <input v-model="search" type="search" @keydown.enter="getPlatforms" @blur="getPlatforms" :placeholder="$t('platforms.enter_site_name')" />
                  <button @click="getPlatforms" class="icon-search" title="Search campaigns">
                    <svg v-svg symbol="search" size="0 0 15 16"></svg>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-3">
            <div class="form-item pb-2">
              <div class="form-item__field">
                <custom-multiselect v-model="trash" :list="filterPeriod" :allowEmpty="false">
                  <template v-slot:block="props">
                    <span>
                      {{ formatLabel(props.value.title) }}
                    </span>
                  </template>
                  <template v-slot:list="props">
                    <span>
                      {{ formatLabel(props.value.title) }}
                    </span>
                  </template>
                </custom-multiselect>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-3">
            <div class="form-item pb-2">
              <div class="form-item__field">
                <router-link @click.native="trackEvent('create_platform_sites')" :to="'/create-platform'" class="btn _w100">+ {{ $t("platforms.create_new") }}</router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <template v-for="platform in bannedRows">
      <div v-if="!hideGSBNotif.includes(platform.id)" :key="platform.id" class="attention-field mb-2">
        <svg class="message-icon mr-1" v-svg style="fill: #fff" symbol="info" size="0 0 17 17" role="info"></svg>
        <p class="mb-0">
          {{ $t("platforms.link_to_traffback") }} <b>{{ platform.id + " " + platform.name }}</b> {{ $t("platforms.blocked_by_gsb") }}
        </p>
        <svg v-svg symbol="close-red" size="24" class="close" @click="hideGSBModal(platform.id)"></svg>
      </div>
    </template>

    <div class="sep _h20"></div>
    <div class="c-table mt-5 mt-md-0">
      <tableAnimation />
      <div class="table-top-scroll">
        <div id="area" :style="{ width: tableWidth + 'px' }"></div>
      </div>

      <div class="inner">
        <vue-good-table styleClass="table  _no-wrap" :columns="columns" :rows="rows">
          <template slot="table-column" slot-scope="props">
            <span @click="toSort(props.column.field)" class="cursor-pointer">
              {{ formatLabel(props.column.label) }}
            </span>
            {{ props.column.field !== "control" ? ":" : "" }}
          </template>
          <template slot="table-row" slot-scope="props">
            <template v-if="props.column.field === 'id'">
              <template v-if="!props.row.trash">
                <button class="platfrom-id" @click="goToStatistic(props.row.id)">
                  {{ props.row.id }}
                </button>
              </template>
              <template v-else>
                {{ props.row.id }}
              </template>
            </template>
            <template v-if="props.column.field === 'name'">
              <svg v-if="featureFlags && featureFlags.includes('subaccount-active-campaigns')" v-svg @click="$router.push(`/active-campaigns/${props.row.id}`)" class="list-icon" symbol="list" size="0 0 17 17"></svg>
              <span v-if="props.row.site" class="label-site">{{ $t("platform.my_site") }}</span>
              <span v-if="props.row.self_hosted_script_outdated" class="label-site label-outdated" v-tooltip="{ content: $t('platform.self_hosted.list_outdated_hint'), triggers: ['hover', 'click'] }">{{ $t("platform.self_hosted.list_outdated") }}</span>
              <router-link v-if="!props.row.current_step && !props.row.trash" class="platform-name" :to="{ name: 'PlatformCard', params: { id: props.row.id, tab: 'general' } }">{{ props.row.name }}</router-link>
              <template v-else>{{ props.row.name }}</template>
            </template>
            <template v-else-if="props.column.field === 'profit'">
              <span class="font-weight-bold">${{ numberFormat(props.row.profit) }}</span>
            </template>
            <template v-else-if="props.column.field === 'payment_model'">
              <span>{{ props.row.payment_model === "revshare" ? "RevShare" : props.row.payment_model }}</span>
            </template>
            <template v-else-if="props.column.field === 'landings'">
              <div class="land-links">
                <ul v-if="props.row.lands && props.row.lands.length > 0">
                  <li v-for="(item, i) in props.row.lands" :key="i">
                    <button @click="openLandModal(item)" class="land-links__item">
                      {{ item.name }}
                    </button>
                  </li>
                </ul>
                <span v-else-if="props.row.url">
                  <a :href="props.row.url" target="__blank">{{ props.row.url }}</a>
                </span>
              </div>
            </template>

            <template v-else-if="props.column.field === 'reference'">
              <div class="row">
                <button v-if="!props.row.current_step" class="btn _text" @click="openLinkModal(props.row)">
                  <span class="icon-link">
                    <svg v-if="props.row.site" v-svg symbol="coolicon" size="0 0 17 11"></svg>
                    <svg v-else v-svg symbol="link" size="0 0 17 17"></svg>
                  </span>
                  {{ $t(`platforms.table.${props.row.site ? "get_code" : "get_link"}`) }}
                </button>
                <button v-else class="btn _text _bg-green" @click="finishPlatform(props.row)">
                  <img title="Dark theme" :src="require('@/assets/images/icons/continue.svg')" />
                  {{ $t("continue") }}
                </button>
              </div>
            </template>

            <template v-else-if="props.column.field === 'control'">
              <ul class="controls">
                <!-- A platform still in the create wizard has no card yet: it is finished with "continue" -->
                <li>
                  <router-link v-if="!props.row.current_step" class="controls__btn" :to="{ name: 'PlatformCard', params: { id: props.row.id, tab: 'general' } }" :title="$t('platform.card.open')" :aria-label="$t('platform.card.open')">
                    <svg v-svg symbol="settings" size="0 0 14 14" role="info"></svg>
                  </router-link>
                  <span v-else class="controls__btn disabled" :title="$t('platform.card.open')">
                    <svg v-svg symbol="settings" size="0 0 14 14" role="info"></svg>
                  </span>
                </li>
                <li>
                  <router-link v-if="!props.row.current_step" class="controls__btn" :to="{ name: 'PlatformCard', params: { id: props.row.id, tab: 'postback' } }" :title="$t('platform.postback')" :aria-label="$t('platform.postback')">
                    <svg v-svg symbol="postback" size="0 0 14 14" role="info"></svg>
                  </router-link>
                  <span v-else class="controls__btn disabled" :title="$t('platform.postback')">
                    <svg v-svg symbol="postback" size="0 0 14 14" role="info"></svg>
                  </span>
                </li>
                <li>
                  <button @click="clonePlatform(props.row.id)" class="controls__btn" :title="$t('copy')" :disabled="Boolean(props.row.current_step)" :class="{ disabled: Boolean(props.row.current_step) }">
                    <svg v-svg symbol="copy" size="0 0 13 15" role="info"></svg>
                  </button>
                </li>
                <li>
                  <button @click="trashPlatform(props.row.id, props.row.trash)" class="controls__btn" :title="$t('select.deselectLabel')">
                    <svg v-if="!trash.value" v-svg class="delete" symbol="delete" size="0 0 15 15" role="info"></svg>
                    <svg v-else v-svg symbol="undo" size="0 0 15 15" role="info"></svg>
                  </button>
                </li>
              </ul>
            </template>
          </template>
          <div class="d-flex justify-content-center" slot="emptystate">
            <template v-if="!loadDataTable">
              {{ $t("any_results") }}
            </template>
            <template v-else>
              <div class="d-flex justify-content-center">
                <img :src="require('@/assets/images/rolling.svg')" alt="loader" class="loader" />
              </div>
            </template>
          </div>
        </vue-good-table>
      </div>
    </div>
    <div class="sep"></div>
    <div class="c-pagination">
      <ul class="pagination" v-if="rows && rows.length && rows.length > 0">
        <li class="page-item">
          <button @click.prevent="page--" :class="{ disabled: page <= 1 }" :disabled="page <= 1" class="page-link icon-prev prev" data-ci-pagination-page="2" rel="prev" :title="$t('statistic.prev')">
            <svg v-svg symbol="prev" size="0 0 8 14"></svg>
          </button>
        </li>
        <li class="page-item">
          <button @click.prevent="page++" :class="{ disabled: page * limit >= total }" :disabled="page * limit >= total" class="page-link icon-next next" data-ci-pagination-page="2" rel="next" :title="$t('statistic.next')">
            <svg v-svg symbol="next" size="0 0 8 14"></svg>
          </button>
        </li>
        <li class="page-item">{{ page === 1 ? page : limit * (page - 1) + 1 }} - {{ limit * (page - 1) + rows.length }} {{ $t("from") }} {{ total }}</li>
        <li>
          <custom-multiselect class="ml-2" v-model="limit" :list="optionsPagination" :allowEmpty="false">
            <template v-slot:block="props">
              <span>
                {{ props.value }}
              </span>
            </template>
            <template v-slot:list="props">
              <span>
                {{ props.value }}
              </span>
            </template>
          </custom-multiselect>
        </li>
      </ul>
    </div>
    <modal @closed="clearSelected" :width="980" name="massModal" height="auto" :scrollable="true" classes="creative-modal overflow-removed" :shiftY="0">
      <PlatformModal :platform="currentPlatform" @closeModal="closeModal" />
    </modal>
    <modal @closed="clearLandingModal" :width="780" name="landModal" height="auto" :scrollable="true" classes="creative-modal" :shiftY="0">
      <LandingModal :landing="currentLanding" @closeModal="closeLandingModal" />
    </modal>
    <alert v-if="$alert.title" />
  </div>
</template>

<script>
import "@/assets/css/_pagination.scss";
import PlatformModal from "@/components/PlatformModal";
import LandingModal from "@/components/LandingModal";
import TableAnimation from "@/components/TableAnimation";
import subaccsService from "@/api/subaccsService";
import LandingMixin from "@/mixins/landModal";

import { mapGetters } from "vuex";

export default {
  name: "Platforms",
  beforeMount() {
    document.title = `Partners.House | ${this.$t("platforms.title")}`;
  },
  beforeUpdate() {
    document.title = `Partners.House | ${this.$t("platforms.title")}`;
  },
  components: {
    TableAnimation,
    PlatformModal,
    LandingModal,
  },
  mixins: [LandingMixin],
  data() {
    return {
      hideGSBNotif: [],
      trash: { title: "platform.active", value: 0 },
      search: null,
      offset: null,
      limit: 10,
      order: null,
      sort: null,
      tableWidth: null,
      loadDataTable: false,
      page: 1,

      platforms: [],
      openLinkModel: false,
      filterPeriod: [
        { title: "platform.active", value: 0 },
        { title: "platform.deleted", value: 1 },
      ],
      currentPlatform: null,
      columns: [
        {
          label: "platforms.table.id",
          field: "id",
          thClass: `sortable spec-sort`,
          sortable: true,
        },
        {
          label: "platforms.table.name",
          field: "name",
          thClass: `sortable spec-sort`,
          sortable: true,
        },
        {
          label: "platforms.table.profit",
          field: "profit",
          thClass: `sortable spec-sort`,
          sortable: true,
        },
        {
          label: "platforms.table.payment",
          field: "payment_model",
          sortable: false,
        },
        {
          label: "platforms.table.landing_pages",
          field: "landings",
          sortable: false,
        },
        {
          label: "platforms.table.reference",
          field: "reference",
          width: "200px",
          sortable: false,
        },
        {
          label: "platforms.table.control",
          field: "control",
          width: "170px",
          sortable: false,
        },
      ],
      rows: [],
      total: null,
      optionsPagination: [10, 25, 50, 100],
    };
  },
  computed: {
    ...mapGetters({
      featureFlags: "user/getFeatureFlags",
    }),
    bannedRows() {
      return this.rows.filter((el) => el.is_traffic_back_banned);
    },
  },
  mounted() {
    this.getPlatforms("checkForGSB");
    const storedState = localStorage.getItem("hideGSBNotif");
    if (storedState) {
      this.hideGSBNotif = JSON.parse(storedState);
    } else {
      this.hideGSBNotif = new Array(this.bannedRows.length).fill(false);
    }

    if (localStorage.getItem("paginationLimit")) {
      this.limit = Number(localStorage.getItem("paginationLimit"));
    }
    this.getPlatforms();
    window.addEventListener("resize", this.tableTopScroll);
  },
  watch: {
    $route: function () {
      const params = this.$route.query;
      this.offset = params.offset || 0;
      if (this.offset === 0) {
        this.page = 1;
      } else {
        this.page = this.offset / this.limit + 1;
      }
    },
    sort: function () {
      this.getPlatforms();
      this.checkTableSpan();
    },
    order: function () {
      this.getPlatforms();
      this.checkTableSpan();
    },
    trash: function () {
      this.getPlatforms();
    },
    limit: function () {
      this.page = 1;
      localStorage.setItem("paginationLimit", this.limit);
      this.getPlatforms();
    },
    offset: function () {
      this.getPlatforms();
    },
    page: function () {
      if (this.page === 1 || this.page < 0) {
        this.offset = null;
        this.$router
          .push({
            path: "/platforms",
          })
          .catch(() => {});
      } else {
        this.offset = this.limit * (this.page - 1);
        this.$router
          .push({
            path: "/platforms",
            query: { offset: this.offset },
          })
          .catch(() => {});
      }
    },
  },
  methods: {
    hideGSBModal(id) {
      this.hideGSBNotif.push(id);

      localStorage.setItem("hideGSBNotif", JSON.stringify(this.hideGSBNotif));
    },
    trackEvent(name) {
      this.$gtm.trackEvent({ event: name });
    },
    formatLabel(el) {
      return this.$t(el);
    },
    finishPlatform(platform) {
      const platfromType = {
        1: "site",
        2: "landing",
      };
      this.$router.push(`/create-platform/${platfromType[platform.site]}/${platform.current_step}?id=${platform.id}`);
    },
    tableTopScroll() {
      this.tableWidth = document.querySelector(".table")?.offsetWidth || 0;
      let tableWrapper = document.querySelector(".table-top-scroll");
      let scrollArea = document.querySelector(".vgt-responsive");

      if (!tableWrapper || !scrollArea) return;

      tableWrapper.onscroll = function () {
        scrollArea.scrollLeft = tableWrapper.scrollLeft;
      };
      scrollArea.onscroll = function () {
        tableWrapper.scrollLeft = scrollArea.scrollLeft;
      };
    },
    trashPlatform(id, trash) {
      subaccsService.trashSubAcc({ id, trash }).then(() => {
        this.getPlatforms();
      });
    },
    checkTableSpan() {
      const thElements = document.querySelectorAll("th.sortable"); // all sortable table columns
      thElements.forEach((thElement) => {
        const spanElement = thElement.querySelector("span"); // span of an current iteration th
        if (spanElement && spanElement.innerText.trim() === this.$t(this.columns.find((el) => el.field === this.sort).label).trim()) {
          // check if an span text === current sort value text
          thElement.classList.remove(
            // remove oposite class
            this.order && this.order === "desc" ? "sorting-asc" : "sorting-desc"
          );
          thElement.classList.add(
            // add class to the current sort th
            this.order && this.order === "desc" ? "sorting-desc" : "sorting-asc"
          );
          return false;
        } else {
          // if no remove all classes
          thElement.classList.remove("sorting-desc", "sorting-asc");
        }
      });
    },
    toSort(val) {
      if (!(val === "landings" || val === "reference" || val === "control" || val === "payment_model")) {
        this.order = this.sort === val ? (this.order === "asc" ? "desc" : "asc") : "desc";
        this.sort = val;
      }
    },
    goToStatistic(id) {
      localStorage.setItem("statisticPlatform", id);
      this.$router.push("/statistic");
    },
    getPlatforms(param) {
      let params = this.$route.query;
      const payload = {
        trash: this.trash.value,
        search: this.search === "" ? null : this.search,
        offset: params.offset ? params.offset : this.offset,
        limit: param === "checkForGSB" ? null : this.limit,
        order: this.order,
        sort: this.sort,
      };
      this.loadDataTable = true;
      subaccsService
        .getSubAccs(payload)
        .then((res) => {
          if (res && res.status === 200) {
            this.rows = res.data.subaccounts;
            this.total = res.data.total;
          }
        })
        .finally(() => {
          this.loadDataTable = false;
          this.tableTopScroll();
        });
    },
    clonePlatform(id) {
      subaccsService.cloneSubAcc(id).then(() => {
        this.getPlatforms();
      });
      this.$alert({
        type: "success",
        title: this.$t("platforms.platform_copied"),
      });
    },
    closeModal() {
      this.$modal.hide("massModal");
      this.clearSelected();
      this.currentPlatform = null;
    },
    openLinkModal(platform) {
      this.currentPlatform = platform;
      this.$modal.show("massModal");
    },
    clearSelected() {
      this.openLinkModel = null;
    },
    numberFormat(str) {
      let num = parseInt(str, 10);
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    },
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.tableTopScroll);
  },
};
</script>

<style lang="scss" scoped>
.platform-name {
  font-weight: 600;
  color: inherit;

  &:hover {
    color: #317475;
    text-decoration: underline;
  }
}

.attention-field {
  display: flex;
  align-items: baseline;
  background: #c84444;
  padding: 12px 30px 12px 10px;
  border-radius: 6px;
  position: relative;
  color: #fff;
  svg.close {
    cursor: pointer;
    fill: #fff;
    opacity: 1;
    position: absolute;
    right: 8px;
    top: 8px;
  }
  svg.message-icon {
    flex-shrink: 0;
    width: 12px;
    height: 12px;
  }
  p {
    line-height: 1.4;
    font-size: 14px;
  }
}

svg.list-icon {
  border: 1px solid #317475;
  padding: 4px;
  height: 22px;
  width: 22px;
  margin-right: 6px;
  border-radius: 5px;
  fill: #317475;
  cursor: pointer;
}

.table-top-scroll {
  width: 100%;
  display: none;
  overflow-x: auto;
  overflow-y: hidden;
  #area {
    height: 20px;
  }
}

@media screen and (min-width: 770px) {
  .table-top-scroll {
    display: block;
  }
}

.loader {
  height: 40px;
}

.content.content_in {
  padding-bottom: 150px;

  &::v-deep {
    table thead th.sortable {
      cursor: pointer;
    }
  }
}

.domain {
  background: linear-gradient(180deg, #44978d 0%, #2a686c 100%);
  border-radius: 15px;
  padding: 25px 35px 10px;
  color: #d9e3e2;
  @media screen and (max-width: 767px) {
    padding: 20px 20px 5px;
  }
  font-size: 14px;
  .btn {
    height: 45px;
  }
  h2 {
    color: #fff;
  }
}

.label-site {
  font-weight: 500;
  font-size: 12px;
  background: #ecd47e;
  border-radius: 3px;
  padding: 4px 5px;
  display: inline-block;
  margin-right: 6px;
  white-space: nowrap;
}

.label-outdated {
  background: #c84444;
  color: #fff;
}

.icon-link {
  svg {
    fill: #317475;
  }
}

.btn._text:hover,
.page-link:hover,
.icon-link:hover {
  svg {
    fill: #fff;
  }
}

.page-link.disabled {
  svg {
    fill: #000109;
  }
}

.platfrom-id {
  display: inline;
  background: transparent;
  transition: 0.3s all ease;

  &:hover {
    color: #2a686c;
  }
}

.land-links {
  overflow: hidden;
  max-width: 520px;
  position: relative;
  @media screen and (max-width: 1600px) {
    max-width: 320px;
  }
  ul {
    display: flex;
    margin: 0 -5px;
    overflow: auto;
    padding: 3px 20px 3px 0;
  }
  li {
    padding: 0 5px;
    .land-links__item {
      display: flex;
      align-items: center;
      height: 28px;
      padding: 0 13px 0 8px;
      position: relative;
      background: #ffffff;
      border: 1px solid #e4e4ea;
      border-radius: 5px;
      font-size: 12px;
      &:before {
        content: "";
        display: block;
        background: url("~@/assets/images/icons/open.svg") center no-repeat;
        background-size: contain;
        width: 7px;
        height: 7px;
        position: absolute;
        top: 3px;
        right: 3px;
        font-size: 7px;
      }
      @media (hover: hover) {
        &:hover {
          border-color: #000109;
          color: #000109;
        }
      }
    }
  }
}
</style>
